import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import {
  SigningCertificateFingerprint,
  SigningCertificateFingerprints,
} from '../../../api'

export const QUERY = gql`
  {
    retrieveSigningCertificateFingerprints {
      items {
        fingerprint
        friendlyName
      }
    }
  }
`

export const retrieveSigningCertificateFingerprints = async (
  client: ApolloClient<unknown>,
): Promise<SigningCertificateFingerprint[]> => {
  const queryResult = await client.query<{
    retrieveSigningCertificateFingerprints: SigningCertificateFingerprints
  }>({
    query: QUERY,
    fetchPolicy: 'no-cache',
  })

  return queryResult.data.retrieveSigningCertificateFingerprints.items
}
